import InputBase from "@mui/material/InputBase";
import Typography from "@mui/material/Typography";
import { useState } from "react";
import * as React from "react";

const InputBaseWithChildren = ({ children, ...props }) => {
  let value = "";
  if (children) {
    if (typeof children == "string" || typeof children == "number") {
      value = children.toString();
    }
  }

  return (
    <InputBase
      {...props}
      className={""}
      value={value}
      inputProps={{ className: props.className }}
    />
  );
};

/**
 * Displaying like a `Typography`. But acting as an `input`
 */
const EditableTypography = ({ onChange: propsOnChange, ...props }) => {
  const [internalValue, setInternalValue] = useState("");

  const value = props.value || internalValue;

  const onChange = (value) => {
    if (propsOnChange) {
      propsOnChange(value);
    }
    setInternalValue(value);
  };

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <Typography
      {...props}
      component={InputBaseWithChildren}
      onChange={handleChange}
    >
      {value}
    </Typography>
  );
};

export default EditableTypography;
